import { render } from "./FamilyItem.vue?vue&type=template&id=0604f4cf"
import script from "./index.js?vue&type=script&lang=js&external"
export * from "./index.js?vue&type=script&lang=js&external"

import "./FamilyItem.vue?vue&type=style&index=0&id=0604f4cf&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__